const baseClasses =
  "inline-flex items-center justify-center rounded-full border focus:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-60";

const defaultInactiveClasses =
  "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:text-slate-900";

export function togglePillButtonClass({
  active,
  className = "",
  activeClassName,
  inactiveClassName = defaultInactiveClasses,
  ringClassName = "focus-visible:ring-blue-500",
}: {
  active: boolean;
  className?: string;
  activeClassName: string;
  inactiveClassName?: string;
  ringClassName?: string;
}): string {
  const state = active ? activeClassName : inactiveClassName;

  return `${baseClasses} ${ringClassName} ${state} ${className}`
    .replace(/\s+/g, " ")
    .trim();
}

